import { abortIfNotPermitted } from '../utils';

export default [
    {
        path: '/',
        component: () =>
            import(/* webpackChunkName: "outlet" */ '@js/franchise_component/setting/devices/device-datatable.vue'),
    },
    {
        path: '/create',
        component: () =>
            import(/* webpackChunkName: "outlet" */ '@js/franchise_component/setting/devices/device-create.vue'),
        beforeEnter: (to, from, next) => {
            /*
            abortIfNotPermitted('franchise_manage_devices', next);
            */

            abortIfNotPermitted('admin_manage_outlets', next);
        },
    },
    {
        path: '/:id',
        component: () =>
            import(/* webpackChunkName: "outlet" */ '@js/franchise_component/setting/devices/device-update.vue'),
    },
];



// WEBPACK FOOTER //
// ./resources/assets/js/router/route-components/device.js